import { render, staticRenderFns } from "./ChildElements.vue?vue&type=template&id=1b1cf8ed&"
import script from "./ChildElements.vue?vue&type=script&lang=js&"
export * from "./ChildElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports